<template>
  <b-modal size="lg" :visible="visible" no-close-on-backdrop no-close-on-esc centered>
    <div slot="modal-header" class="w-100">
      <h5>Invite Participating Provider
        <button type="button" class="close" @click.prevent="closeModal()">
          <span aria-hidden="true">&times;</span></button>
      </h5>
    </div>
    <b-form>
      <div class="container-fluid visit-charge-body">
        <div class="row justify-content-center m-2">
          <div class="alert alert-danger col" role="alert" v-show="generalErrorMessage">
            <div>{{ generalErrorMessage }}</div>
          </div>
        </div>
        <div class="row">
          <div class="col-2">
          </div>

          <div class="col-8">
            <b-form-group :label-cols="4" label="Provider/Facility" label-align="right" :state="stateForField('organizationPayeeId')" :invalid-feedback="errorForField('organizationPayeeId')">
              <b-dropdown menu-class="dropdown-container" :text="payeeName" :variant="hasError('organizationPayeeId') ? 'outline-danger' : 'outline-dark'">
                <b-dropdown-item  v-for="payee in payees" :key="payee.organizationPayeeId" @click.prevent="setPayee(payee)">{{ payeeDisplayName(payee) }}
                </b-dropdown-item>
              </b-dropdown>
            </b-form-group>

            <b-form-group :label-cols="4" label="Email" label-align="right" :state="stateForField('email')" :invalid-feedback="errorForField('email')">
              <b-form-input v-model="payee.email"></b-form-input>
            </b-form-group>
          </div>
        </div>
      </div>
    </b-form>
    <div slot="modal-footer" class="w-100">
      <button type="button" class="btn btn-orange float-right" @click.prevent="save()">
        <font-awesome-icon size="lg" class="mr-2" v-show="isSaving" icon="spinner" pulse/>
        Save
      </button>
      <button type="button" class="btn btn-outline-orange mr-2 float-right" @click.prevent="closeModal()">Close</button>
    </div>
  </b-modal>
</template>

<script>
  import ErrorsMixin from '@/mixins/ErrorsMixin'
  import api from '@/services/api'

  export default {
    name: 'PayeeInviteModal',

    mixins: [ErrorsMixin],

    components: { },

    props: {
      visible: {
        type: Boolean,
        required: true
      }
    },

    data () {
      return {
        payee: {
          email: '',
          organizationPayeeId: 0
        },
        payees: [],
        payeeName: 'Click to select',
        isSaving: false
      }
    },

    watch: {
      visible (newValue) {
        if (newValue && this.payees.length === 0) {
          this.loadPayees()
        }
      }
    },

    computed: {
    },

    methods: {
      validate () {
        this.clearAllErrors()

        if (!this.payee.email) {
          this.addErrorForField('email', 'You must provide your email')
        }

        return !this.hasErrors()
      },

      save () {
        if (this.isSaving) {
          return
        }

        if (!this.validate()) {
          return
        }

        this.clearAllErrors()

        this.isSaving = true
        api.post('/Dashboard/Payee/Invite', this.payee).then(response => {
          this.$emit('payeeInvited', response.data)
        }).catch(error => {
          if (!this.$store.canHandleNetworkError(error)) {
            this.setFromApiErrorResponse(error)
            this.$log.error('Error attempting to invite payee: ' + error.message, error)
          }
        }).then(() => {
          this.isSaving = false
          this.payee = {
            email: '',
            organizationPayeeId: 0
          }
          this.payeeName = 'New Provider/Facility'
        })
      },

      loadPayees () {
        api.get('/Dashboard/Payees').then(response => {
          const payees = response.data
          payees.unshift({ organizationPayeeId: 0, businessName: 'New Provider/Facility' })
          this.payees = payees
        }).catch(error => {
          if (!this.$store.canHandleNetworkError(error)) {
            this.setFromApiErrorResponse(error)
            this.$log.error('Error attempting to load payees: ' + error.message, error)
          }
        })
      },

      payeeDisplayName (payee) {
        let displayName = ''

        if (payee.businessName) {
          return payee.businessName
        }

        if (payee.users.length >= 1) {
          const payeeUser = payee.users[0].user

          if (payeeUser && payeeUser.firstName) {
            if (displayName) {
              displayName += ', '
            }
            displayName += payeeUser.firstName
          }

          if (payeeUser && payeeUser.lastName) {
            displayName += ' ' + payeeUser.lastName
          }
        }

        return displayName
      },

      setPayee (payee) {
        this.payeeName = this.payeeDisplayName(payee)
        this.payee.organizationPayeeId = payee.organizationPayeeId
      },

      closeModal () {
        this.$emit('update:visible', false)
      }
    }
  }
</script>

<style scoped>

</style>
